import React, {
  Component,
  Fragment,
  useEffect,
  useState
} from "react";
import {
  Input,
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  FormFeedback,
  FormText,
  Form
} from "reactstrap";
import { connect } from "react-redux";
import { clearUpdateOrganisationError, updateOrganisation } from "../../store/organisationDetails/actions";
import Message from "../../CommonData/Data/Message";
import { updateForm } from "../../store/form/actions";
import Async from "react-select/async";
import { getFilteredStatesForAsyncSelect } from "../../store/actions";
import VWLoading from "../../components/vwLoading/vwLoading";
import Select from "react-select";
import { orgTypeOption } from "../../store/organisation/actionTypes.js";

const EditOrganisation = (props) => {

  const { organisationDetails, handleClose, errorMessage, form, isPending } = props || {};
  const { formUpdateOrg } = form || {};
  const [selected_state, setState] = useState();
  const [selectedOrgType, setOrgType] = useState();
  console.log("organisationDetails: ", organisationDetails);
  useEffect(() => {
    if (organisationDetails) {
      const { address, name, description, active, id, applicationLogo, applicationName, approveNewCustomer,
        allowCustomerSelfRegistration, enableUserMailNotification, isReturnApproval, orgType, isEnableApiAccess,
        isEnableOnlySwitchMobileApp, disableUserLogin, disableDeviceAssignment } = organisationDetails || {};
      const state_data = {
        label: address.state,
        value: address.state
      }
      const OrgType_data = {
        label: orgType || "Select organization type",
        value: orgType
      }
      setState(state_data);
      setOrgType(OrgType_data);
      const data = {
        id: id || null,
        name: name || null,
        orgType: orgType || null,
        active: active || null,
        description: description || null,
        addressLine1: address.addressLine1 || null,
        addressLine2: address.addressLine2 || null,
        city: address.city || null,
        state: address.state || null,
        country: address.country || null,
        pincode: address.pincode || null,
        approveNewCustomer: approveNewCustomer || false,
        allowCustomerSelfRegistration: allowCustomerSelfRegistration || false,
        enableUserMailNotification: enableUserMailNotification || false,
        isReturnApproval: isReturnApproval || false,
        isEnableApiAccess: isEnableApiAccess || false,
        isEnableOnlySwitchMobileApp: isEnableOnlySwitchMobileApp || false,
        disableUserLogin: disableUserLogin || false,
        disableDeviceAssignment: disableDeviceAssignment || false,
        applicationLogo: applicationLogo || null,
        applicationName: applicationName || null,
      }
      props.updateForm({
        formUpdateOrg: data,
        errors: {}
      })
    }
    props.clearUpdateOrganisationError();
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleClearLogo = () => {
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
        applicationLogo: null
      },
      errors: {
        ...form && form.errors,
      }
    })
  }

  const handleInputChange = (event) => {
    const { name } = event.target;
    const input = event.target;
    const value = input.type === 'checkbox' ? input.checked : input.value;
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    })
  }
  const handleLoadStates = (inputValue, callback) => {
    props.getFilteredStatesForAsyncSelect(inputValue, callback);
  };

  const handleStateChange = (value) => {
    setState(value);
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
        state: value ? value.value : "",
      },
      errors: {
        ...form && form.errors,
        state: null,
      }
    });
  }
  const handleOrgTypeChange = (value) => {
    setOrgType(value);
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
        orgType: value ? value.value : "",
      },
      errors: {
        ...form && form.errors,
        orgType: null,
      }
    });
  }

  const handleOrgActiveChange = () => {
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
        active: !formUpdateOrg.active
      },
      errors: {
        ...form && form.errors,
      }
    })
  };

  const handleKeyDown = (e) => {
    if (e.key === ",") {
      e.preventDefault();
    }
  };

  const handleLogoChange = (event) => {
    const filedata = event.target.files[0];
    if (filedata) {
      const img = new Image();
      const reader = new FileReader();
      const imageSize = filedata.size;
      const imageSizeInKB = imageSize / 1024;

      reader.onloadend = () => {
        img.src = reader.result;
        img.onload = () => {
          if (imageSizeInKB > 200) {
            props.updateForm({
              formUpdateOrg: {
                ...form.formUpdateOrg,
                applicationLogo: null,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: "Image size should below 200 kb.",
              }
            });
          }
          else if (img.width > 900 || img.height > 350) {
            props.updateForm({
              formUpdateOrg: {
                ...form.formUpdateOrg,
                applicationLogo: null,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: "Image dimensions should not exceed 900px in width and 350px in height.",
              }
            });
          }
          else {
            props.updateForm({
              formUpdateOrg: {
                ...form.formUpdateOrg,
                applicationLogo: reader.result,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: null,
              }
            });
          }
        };
      };
      reader.readAsDataURL(filedata);
    }
  }

  const handleUpdateOrganisation = (e) => {
    e.preventDefault();
    const { formUpdateOrg, errors } = form || {};
    const { name, orgType, addressLine1, city, state, country, pincode } = formUpdateOrg || {};
    const { applicationLogo } = errors || {};

    const currentErrors = {};

    if (!name) {
      currentErrors.name = "Name is required"
    }
    if (!orgType) {
      currentErrors.orgType = "Organization type is required"
    }
    if (!addressLine1) {
      currentErrors.addressLine1 = "Address is required"
    }
    if (!city) {
      currentErrors.city = "City is required"
    }
    if (!state) {
      currentErrors.state = "State is required"
    }
    if (!country) {
      currentErrors.country = "Country is required"
    }
    if (!pincode) {
      currentErrors.pincode = "Pincode is required"
    }
    if (applicationLogo) {
      currentErrors.applicationLogo = applicationLogo
    }
    props.updateForm({
      formUpdateOrg: {
        ...form.formUpdateOrg,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.updateOrganisation({
        ...form.formUpdateOrg,
        address: {
          addressLine1: form.formUpdateOrg.addressLine1,
          addressLine2: form.formUpdateOrg.addressLine2,
          city: form.formUpdateOrg.city,
          state: form.formUpdateOrg.state,
          country: form.formUpdateOrg.country,
          pincode: form.formUpdateOrg.pincode,
        }
      });

    }
  };
  return isPending ? (<VWLoading />) : (
    <Fragment>
      {formUpdateOrg && (
        <Form className="mb-3" name="formUpdateOrganisation" onSubmit={handleUpdateOrganisation}>
          {errorMessage && (
            <Message
              type="danger"
              defaultMessage={errorMessage}
              baseClassName="alert"
            />
          )}
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Name<span className="text-danger">*</span>
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="name"
                  placeholder="Enter organization name"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.name}
                  invalid={form && form.errors && form.errors.name}
                />
                <FormFeedback>{form && form.errors && form.errors.name}</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Organization Type<span className="text-danger">*</span>
                </Label>
                <Select
                  className="text-capitalize"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: (form && form.errors && form.errors.orgType) ? 'red' : ""
                    })
                  }}
                  placeholder="Select organization type"
                  defaultOptions
                  options={orgTypeOption}
                  onChange={handleOrgTypeChange}
                  value={selectedOrgType || { label: "Select organization type", value: null }}
                />
                {(form && form.errors && form.errors.orgType) &&
                  <FormText sx={{ marginLeft: "10px" }}>
                    <div className="text-danger">
                      {form && form.errors && form.errors.orgType}
                    </div>
                  </FormText>
                }
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Address Line 1<span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  name="addressLine1"
                  placeholder="Enter address"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.addressLine1}
                  invalid={form && form.errors && form.errors.addressLine1}
                  onKeyDown={handleKeyDown}
                />
                <FormFeedback>{form && form.errors && form.errors.addressLine1}</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Address Line 2
                </Label>
                <Input
                  type="textarea"
                  name="addressLine2"
                  placeholder="Enter address"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.addressLine2}
                  onKeyDown={handleKeyDown}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  City<span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="city"
                  placeholder="Enter city"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.city}
                  invalid={form && form.errors && form.errors.city}
                />
                <FormFeedback>{form && form.errors && form.errors.city}</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  State<span className="text-danger">*</span>
                </Label>
                <Async
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: (form && form.errors && form.errors.state) ? 'red' : ""
                    })
                  }}
                  placeholder="Select State"
                  defaultOptions
                  loadOptions={handleLoadStates}
                  onChange={handleStateChange}
                  value={selected_state}
                />
                {(form && form.errors && form.errors.state) &&
                  <FormText sx={{ marginLeft: "10px" }}>
                    <div className="text-danger">
                      {form && form.errors && form.errors.state}
                    </div>
                  </FormText>
                }

              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Country<span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="country"
                  placeholder="Enter country"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.country}
                  invalid={form && form.errors && form.errors.country}
                />
                <FormFeedback>{form && form.errors && form.errors.country}</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>
                  Pincode<span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="pincode"
                  placeholder="Enter pincode"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.pincode}
                  invalid={form && form.errors && form.errors.pincode}
                />
                <FormFeedback>{form && form.errors && form.errors.pincode}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>Application Name</Label>
                <Input
                  name='applicationName'
                  type='text'
                  placeHolder='Enter application name'
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.applicationName}
                />
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>Application Logo</Label>
                {formUpdateOrg && formUpdateOrg.applicationLogo ?
                  <>
                    <br />
                    <img
                      src={formUpdateOrg.applicationLogo}
                      alt='logo'
                      style={{
                        height: "80px",
                        width: "auto"
                      }}
                    />
                    <Button
                      className='ms-4 px-2 py-0'
                      color='danger'
                      onClick={handleClearLogo}
                    >
                      <i className="mdi mdi-close fs-4 p-0" />
                    </Button>
                  </>
                  : <>
                    <Input
                      name='applicationLogo'
                      type='file'
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleLogoChange}
                      invalid={form && form.errors && form.errors.applicationLogo}
                    />
                    <FormFeedback>{form && form.errors && form.errors.applicationLogo}</FormFeedback>
                  </>
                }
              </FormGroup>
            </Col>
          </Row>
          <Row className="d-flex align-items-center">
            <Col md={6} sm={12}>
              <FormGroup>
                <Label>Description</Label>
                <Input
                  type="textarea"
                  name="description"
                  placeholder="Enter description"
                  onChange={handleInputChange}
                  value={formUpdateOrg && formUpdateOrg.description}
                />
              </FormGroup>
            </Col>
            <Col md={6} sm={12} className="mt-4">
              <FormGroup>
                <Input
                  className="me-2"
                  type="checkbox"
                  name="approveNewCustomer"
                  onChange={handleInputChange}
                  checked={formUpdateOrg && formUpdateOrg.approveNewCustomer}
                />
                <Label>
                  Approve New Customer?
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6} sm={12}>
              <FormGroup>
                <Input
                  className="me-2"
                  type="checkbox"
                  name="allowCustomerSelfRegistration"
                  onChange={handleInputChange}
                  checked={formUpdateOrg && formUpdateOrg.allowCustomerSelfRegistration}
                />
                <Label>
                  Allow Customer Self Registration?
                </Label>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup>
                <Input
                  className="me-2"
                  type="checkbox"
                  name="enableUserMailNotification"
                  onChange={handleInputChange}
                  checked={formUpdateOrg && formUpdateOrg.enableUserMailNotification}
                />
                <Label>
                  Enable Email Notification To Customer?
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup>
                <Input
                  className="me-2"
                  type="checkbox"
                  name="isReturnApproval"
                  onChange={handleInputChange}
                  checked={formUpdateOrg && formUpdateOrg.isReturnApproval}
                />
                <Label>
                  Enable Return Device Without Approval?
                </Label>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <Input
                className="me-2"
                type="checkbox"
                name="isEnableApiAccess"
                onChange={handleInputChange}
                checked={formUpdateOrg && formUpdateOrg?.isEnableApiAccess || ""}
              />
              <Label>
                Enable API Access?
              </Label>
            </Col>
            <Col md={6} sm={12} className="mb-4">
              <Input
                className="me-2"
                type="checkbox"
                name="isEnableOnlySwitchMobileApp"
                onChange={handleInputChange}
                checked={formUpdateOrg && formUpdateOrg?.isEnableOnlySwitchMobileApp || ""}
              />
              <Label>
                Enable Only Switch Mobile App?
              </Label>
            </Col>
            <Col md={6} sm={12}>
              <Input
                className="me-2"
                type="checkbox"
                name="disableDeviceAssignment"
                onChange={handleInputChange}
                checked={formUpdateOrg && formUpdateOrg?.disableDeviceAssignment || ""}
              />
              <Label>
                Disable Device Assignment?
              </Label>
            </Col>
            <Col md={6} sm={12} className="mb-4">
              <Input
                className="me-2"
                type="checkbox"
                name="disableUserLogin"
                onChange={handleInputChange}
                checked={formUpdateOrg && formUpdateOrg?.disableUserLogin || ""}
              />
              <Label>
                Disable User Login?
              </Label>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Label>Organization Status</Label><br />
              <small>
                You can active or inactive the organization account. This will
                prevent user's sign in who belongs to the organization.
              </small>
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <ul className="form-unstyled-list form-status-list mt-2">
                <li
                  onClick={handleOrgActiveChange}
                  className={`form-status-item ${!formUpdateOrg.active ? "active" : ""}`}
                >
                  Inactive
                </li>
                <li
                  onClick={handleOrgActiveChange}
                  className={`form-status-item ${formUpdateOrg.active ? "active" : ""}`}
                >
                  Active
                </li>
              </ul>
            </Col>
          </Row>
          <FormGroup className="mt-4">
            <Button
              type="submit"
              className='me-4'
              color="success"
              onClick={handleUpdateOrganisation}
            >
              Update
            </Button>
            <Button
              color="danger"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </FormGroup>
        </Form>
      )}
    </Fragment >
  );
}

const mapStateToProps = (state) => ({
  isPending: state.organisationDetails.isUpdateOrganisationPending,
  errorMessage: state.organisationDetails.updateOrganisationErrorMessage,
  organisationDetails: state.organisationDetails.organisation,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddOrganisation) => dispatch(updateForm(AddOrganisation)),
  updateOrganisation: (organisation) => dispatch(updateOrganisation(organisation)),
  clearUpdateOrganisationError: () => dispatch(clearUpdateOrganisationError()),
  getFilteredStatesForAsyncSelect: (searchValue, callback) => dispatch(getFilteredStatesForAsyncSelect(searchValue, callback)),

});

export default connect(mapStateToProps, mapDispatchToProps)(EditOrganisation);
